import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useEffect, useRef } from 'react';

import { TotalContributionBoxStyled, TotalContributioRowStyled } from './EditContributionDrawerStyled';
import { ScheduledContributionDto } from 'enrollment/queries/useV3ContributionAmountQuery';
import { convertCurrency } from 'enrollment/utils';
import { AdjustContributionBanner } from "./AdjustContributionBanner";
import { hsaContributionsIntial } from 'enrollment/services';
import { getTotalContributionAmount } from 'enrollment/components/ContributionsCard/utils';


interface TotalContributionBoxProps {
  localScheduledContributions: ScheduledContributionDto[]; // Replace 'any' with the appropriate type if known
  adjustContrubtionAmount: (adjuContributionBanner:string, balanceContributionAmount:number) => void;
  perPayPeriodContributionsUpdated: number;
  exceedsTotalContribution: boolean;
  setExceedsTotalContribution: (value: boolean) => void;
  initialTotalContributionAmount: number;
}

export function TotalContributionBox({ localScheduledContributions, adjustContrubtionAmount, perPayPeriodContributionsUpdated, exceedsTotalContribution, setExceedsTotalContribution, initialTotalContributionAmount }: TotalContributionBoxProps) {
   const drawerRef = useRef<HTMLDivElement | null>(null);
   const { t } = useTranslation('pages.financial');
   const newHsaData = useSelector(hsaContributionsIntial);
   const employeeMaxContributionAmount = Number(newHsaData?.employee_contribution_details?.calculated_subscriber_max);
   const employerMaxContributionAmount = Number(newHsaData?.employer_contribution_details?.total_org_contribution_amount) + Number(newHsaData?.employer_contribution_details?.total_er_lump_sum_contribution_amount);
   const maxContribution = employeeMaxContributionAmount + employerMaxContributionAmount;
   const subscriberMax = useSelector(hsaContributionsIntial)?.employee_contribution_details?.calculated_subscriber_max;
   const isScreenSmall = window.innerWidth < 821;
   const totalContribution = getTotalContributionAmount(localScheduledContributions);
   let totalEmployerContribution = 0;
   let totalSubscriberContribution = 0;
   localScheduledContributions?.forEach(payPeriod => {
     totalEmployerContribution += Number(payPeriod.scheduled_employer_contribution) + Number(payPeriod.scheduled_employer_lump_sum_contribution);
     totalSubscriberContribution += Number(payPeriod.scheduled_subscriber_contribution) + Number(payPeriod.scheduled_subscriber_lump_sum_contribution);
   });

  useEffect(() => {
    setExceedsTotalContribution(totalContribution > maxContribution || totalSubscriberContribution > Number(subscriberMax));
      if (drawerRef.current && (totalContribution > maxContribution || totalSubscriberContribution > Number(subscriberMax))) {
        drawerRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
      }
    }, [localScheduledContributions, maxContribution, setExceedsTotalContribution, totalContribution]);

  return (
    <>
      <TotalContributionBoxStyled className="total-toolbox p-3 mt-5" >
        <div className={`m-2 mb-4 ${isScreenSmall ? "pb-1" : "pb-3"}`}>
            <TotalContributioRowStyled className={`total-contribution m-2 d-flex align-items-center semiBold ${isScreenSmall ? "justify-content-between" : "justify-content-end" }`}>
                <div className='mr-5 totalText'>{t('editContribution.total')}</div>
                <div>{convertCurrency(totalContribution.toString())}</div>
            </TotalContributioRowStyled>
            <div className={`maximum-contribution ${isScreenSmall && "text-center"}`}>
                <span className='mr-2'>{t('editContribution.maxContribution')}</span>
                <span>{convertCurrency(maxContribution.toString())}</span>
            </div>
        </div>

        <div className={`mb-4  ${isScreenSmall ? "px-3 d-flex justify-content-between align-items-center" : "row mr-3 justify-content-end"}`}>
            <div>{t('editContribution.employerContribution')}</div>
            <div className='semiBold pl-4'>{convertCurrency(totalEmployerContribution.toString())}</div>
        </div>
        <div className={`mb-4  ${isScreenSmall ? "px-3 d-flex justify-content-between align-items-center" : "row mr-3 justify-content-end"}`}>
            <div>{t('editContribution.employeeContribution')}</div>
            <div className='pl-4 semiBold'>{convertCurrency(totalSubscriberContribution.toString())}</div>
        </div>
        {!exceedsTotalContribution &&
          <AdjustContributionBanner
            totalContribution={totalContribution}
            adjustContrubtionAmount={adjustContrubtionAmount}
            perPayPeriodContributionsUpdated={perPayPeriodContributionsUpdated}
            localScheduledContributions={localScheduledContributions}
            initialTotalContributionAmount={initialTotalContributionAmount}/>}
        {exceedsTotalContribution &&
          <div className='invalid-amount p-2_5' role='alert'>
              {t('editContribution.exceedsTotalContribution')}
          </div>
        }
      </TotalContributionBoxStyled>
      <div className='alertRef' ref={drawerRef}></div>
    </>
  );
}
